<div>
  <div style="display: flex">
    <span class="title-text">Banners for:</span>
    <div class="filter-dropdown">
      <p-dropdown
        [options]="displayWeekOptions"
        [(ngModel)]="currentDisplayWeek"
        name="displayWeekOption"
        (onChange)="onDisplayWeekChange($event)"
      ></p-dropdown>
    </div>
  </div>
  <div class="subtitle-text">
    {{ selectedDisplayWeek.title }}
  </div>
</div>

<div cdkDropList (cdkDropListDropped)="onBannerDropped($event)">
  <table class="banner-table header" style="width: 100%">
    <thead>
      <tr>
        <td class="center col1">Position</td>
        <td class="center col2">Image</td>
        <td class="left">Details</td>
        <td class="left col4">Start</td>
        <td class="left col5">End</td>
        <td class="left col6">Category</td>
        <td class="center col7">Status</td>
        <td class="center col8">Action</td>
      </tr>
    </thead>
  </table>

  <div class="drag-container">
    <div
      style="border-radius: 5px; border: 1px solid #ccc; margin-bottom: 5px; overflow: hidden"
      *ngFor="let banner of displayBanners; let i = index"
      cdkDrag
      cdkDragBoundary=".drag-container"
      [cdkDragData]="banner"
      cdkDragLockAxis="y"
    >
      <div class="custom-placeholder" *cdkDragPlaceholder></div>
      <ng-container
        *ngTemplateOutlet="tableTemplate; context: { $implicit: banner, index: i }"
      ></ng-container>

      <ng-template cdkDragPreview matchSize="true">
        <div class="drag-preview">
          <ng-container
            *ngTemplateOutlet="tableTemplate; context: { $implicit: banner, index: i }"
          ></ng-container>
        </div>
      </ng-template>
    </div>
    <div *ngIf="isBannerAdministrator" class="add-banner-box" (click)="createBanner()">
      <i class="fa fa-plus"></i>&nbsp;Create Banner
    </div>
  </div>

  <div *ngIf="upcomingBanners?.length > 0">
    <!-- show upcoming banners if set -->
    <div class="upcoming">
      <div class="title-text">Scheduled {{ selectedDisplayWeek.label }} banners</div>
      <div class="subtitle-text">A list of upcoming banners</div>

      <div *ngFor="let banner of upcomingBanners">
        <ng-container
          *ngTemplateOutlet="tableTemplate; context: { $implicit: banner, noDrag: true }"
        ></ng-container>
      </div>
    </div>
  </div>
</div>

<ng-template #tableTemplate let-banner let-noDrag="noDrag" let-index="index">
  <table
    class="banner-table"
    style="width: 100%; cursor: grab"
    [pTooltip]="noDrag ? '' : 'Drag and drop banners to change order'"
  >
    <tbody>
      <tr>
        <td class="col1 align-center position-td">
          <span class="position">
            {{ index + 1 }}
          </span>
        </td>
        <td class="col2">
          <div class="image-cell">
            <img src="{{ banner.presignedImageURL }}" width="150" alt="banner-image" />
          </div>
        </td>
        <td>
          <div class="desc-line-1">{{ banner.title }}</div>
          <div class="desc-line-2">{{ banner.description }}</div>
        </td>
        <td class="col4">
          <div>{{ banner.showFrom | datex : 'ddd DD MMM' }}</div>
        </td>
        <td class="col5">
          <div>{{ (banner.showUntil | datex : 'ddd DD MMM') || 'Until Discontinued' }}</div>
        </td>
        <td class="col6">
          <div class="category" [pTooltip]="banner.bannerCategory.name">
            {{ banner.bannerCategory.abbr }}
          </div>
        </td>
        <td class="col7 align-center">
          <!-- running, archived, draft, scheduled -->
          <div class="status" [ngClass]="statusClass(banner.status)">
            <span class="bull">&bull;</span> {{ banner.status }}
          </div>
        </td>
        <td class="col8">
          <div *ngIf="isBannerAdministrator" class="actions">
            <div class="action-item" (click)="editBanner(banner)">
              <i class="fa-15x fa fa-pencil"></i>
            </div>
            <div class="action-item" (click)="deleteBanner(banner)">
              <i class="fa-15x fa fa-trash"></i>
            </div>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</ng-template>

<!--<ng-template #noBanners>-->
<!--  <div>No banners matching the current filter/tab selection</div>-->
<!--</ng-template>-->
